package er.prateek.crossly.ui.theme

enum class ThemeMode {
    SYSTEM,
    LIGHT,
    DARK,
}
